import Vue from 'vue'
import Router from 'vue-router'

import store from './store/index'

import Docs from './views/Docs.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      props: true,
      component: () => import('./views/Login.vue'),
      meta: {
        hiddenNav: true,
        recaptchaAlert: true
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "register" */ './views/Register.vue'),
      meta: {
        hiddenNav: true,
        recaptchaAlert: true
      }
    },
    {
      path: '/index.html',
      redirect: '/docs'
    },
    {
      path: '/',
      redirect: '/docs',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/docs/:query?',
      name: 'docs',
      component: Docs,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/doc/:id',
      name: 'doc',
      component: () => import('./views/Document.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import(/* webpackChunkName: "settings" */ './views/Settings.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/contractors',
      name: 'contractors',
      component: () => import(/* webpackChunkName: "contractors" */ './views/Contractors.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/organization',
      name: 'manage-organization',
      component: () => import(/* webpackChunkName: "organizations" */ './views/organizations/ManageOrganization.vue'),
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/scan',
      name: 'scan',
      component: () => import(/* webpackChunkName: "scan" */ './views/Scan.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/add/warehouse-doc',
      name: 'add-invoice',
      component: () => import(/* webpackChunkName: "invoice" */ './views/AddWarehouseDoc.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/add/invoice',
      name: 'add-invoice',
      component: () => import(/* webpackChunkName: "invoice" */ './views/AddInvoice.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/edit-invoice/:id',
      name: 'edit-invoice',
      component: () => import(/* webpackChunkName: "invoice" */ './views/EditInvoice.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/edit-warehouse-doc/:id',
      name: 'edit-warehouse-doc',
      component: () => import(/* webpackChunkName: "warehouse-doc" */ './views/EditWarehouseDoc.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/add-document',
      name: 'add-document',
      component: () => import(/* webpackChunkName: "document" */ './views/AddDocument.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/join-organization',
      name: 'join-organization',
      component: () => import(/* webpackChunkName: "register" */ './views/organizations/JoinOrganization.vue'),
      meta: {
        hiddenNav: true,
        requiresAuth: true,
        withoutOrganizations: true
      }
    },
    {
      path: '/reports',
      name: 'reports',
      component: () => import(/* webpackChunkName: "document" */ './views/Reports.vue'),
      meta: {
        requiresAuth: true
      }
    },
  ]
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(rec => rec.meta.requiresAuth)) {
    if(!store.getters['user/isLogged']) {
      next({
        name: 'login',
        params: { nextURL: to.fullPath }
      })
    } else if(store.state.user.user.organizations.length == 0 && !to.matched.some(rec => rec.meta.withoutOrganizations)) {
      next({
        name: 'join-organization',
        params: {nextURL: to.fullPath}
      })
    } else {
      next()
    }
  } else {
    if(store.getters['user/isLogged']) {
      next('/')
    } else {
      next()
    }
  }
})

export default router
